var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4995 21.75C5.84951 21.75 1.24951 17.15 1.24951 11.5C1.24951 5.85 5.84951 1.25 11.4995 1.25C17.1495 1.25 21.7495 5.85 21.7495 11.5C21.7495 17.15 17.1495 21.75 11.4995 21.75ZM11.4995 2.75C6.66951 2.75 2.74951 6.68 2.74951 11.5C2.74951 16.32 6.66951 20.25 11.4995 20.25C16.3295 20.25 20.2495 16.32 20.2495 11.5C20.2495 6.68 16.3295 2.75 11.4995 2.75Z",
    fill: "#A2A9AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0014 22.7475C21.8114 22.7475 21.6214 22.6775 21.4714 22.5275L19.4714 20.5275C19.1814 20.2375 19.1814 19.7575 19.4714 19.4675C19.7614 19.1775 20.2414 19.1775 20.5314 19.4675L22.5314 21.4675C22.8214 21.7575 22.8214 22.2375 22.5314 22.5275C22.3814 22.6775 22.1914 22.7475 22.0014 22.7475Z",
    fill: "#A2A9AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.60d80206bf212574c905a0875b5ba3e0.svg";
export { ForwardRef as ReactComponent };